// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const AutoRulesService = {
    /**
     * Rule is a gRPC endpoint that returns the specified Rule.
     * This endpoint will only return the rule if the user has read access to the asset.
     */
    Rule(fn, req) {
        try {
            fm.validateUrlParam(req["ruleId"], "ruleId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-rules/v1/rules/${req["ruleId"]}?${fm.renderURLSearchParams(req, ["ruleId"])}`, { method: "GET" });
    },
    /**
     * CreateRule creates a new Rule.
     * created_at is set to the current timestamp.
     * This endpoint will only create the rule if the user has edit access to all
     * business groups associated with the rule being created.
     */
    CreateRule(fn, req) {
        return fn(`/messaging/auto-rules/v1/rules`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * UpdateRule is a gRPC endpoint that updates a Rule.
     * This method is to be treated like a patch. If members of the request are null then no update should be made to
     * that column. user_id is updated to the current timestamp.
     * A user can edit this asset if they have access through locations currently associated with the rule, HOWEVER
     * a user must have access through all business groups that would be newly associated with this asset.
     */
    UpdateRule(fn, req) {
        try {
            fm.validateUrlParam(req["ruleId"], "ruleId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-rules/v1/rules/${req["ruleId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * DeleteRule is a gRPC endpoint that deletes the specified Rule.
     * deleted_at is updated to the current timestamp.
     * This endpoint will only delete the rule if the user has edit access to the asset.
     */
    DeleteRule(fn, req) {
        try {
            fm.validateUrlParam(req["ruleId"], "ruleId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-rules/v1/rules/${req["ruleId"]}?${fm.renderURLSearchParams(req, ["ruleId"])}`, { method: "DELETE" });
    },
    /**
     * ToggleRule is a gRPC endpoint that allows enabling/disabling a Rule.
     * A user can toggle a rule if they have access through locations currently associated with the rule.
     */
    ToggleRule(fn, req) {
        try {
            fm.validateUrlParam(req["ruleId"], "ruleId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-rules/v1/rules/${req["ruleId"]}/toggle`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ListRules is a gRPC endpoint that returns a list of Rules given some filters.
     * Available filters are:
     * - enabled: return rules that are enabled or disabled
     * - business_groups: return rules that are associated with the provided business groups
     * - processing_strategy: return rules that use a send strategy in the provided list
     * - valid_at: return rules as they were at a given time.
     * Only returns rules that the user has read access to, if provided. User is optional.
     * Only returns rules for which the org has customization flags enabled.
     */
    ListRules(fn, req) {
        return fn(`/messaging/auto-rules/v1/rules?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * RuleHistory is a gRPC endpoint that returns a list of Rules the represent the history of the Rule.
     * A user can view the history of a rule if they have access through locations currently associated with the rule.
     */
    RuleHistory(fn, req) {
        try {
            fm.validateUrlParam(req["ruleId"], "ruleId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/auto-rules/v1/rules/${req["ruleId"]}/history?${fm.renderURLSearchParams(req, ["ruleId"])}`, { method: "GET" });
    },
    /**
     * ListAutoMessageTypes returns a list of all MessageTypes that apply to the specified organization.
     * Using this endpoint requires no user or user grants.
     */
    ListAutoMessageTypes(fn, req) {
        return fn(`/messaging/auto-rules/v1/message-types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * PreviewEmailTemplate renders the email template for preview.
     */
    PreviewEmailTemplate(fn, req) {
        return fn(`/messaging/auto-rules/v1/preview-email-template`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
